import type { ComposerReply } from "../../src/personal-composer-contract.ts";
import type { RecipientText } from "./recipient-input.ts";

/** A stored part's limit; a line is kept as consecutive parts and put back by joining them. */
const PART = 320;
const MAX_PARTS = 50;

const parts = (line: string): string[] => {
  const out: string[] = [];
  for (let at = 0; at < line.length && out.length < MAX_PARTS; at += PART)
    out.push(line.slice(at, at + PART));
  return out;
};

/**
 * The whole reply a box would save beside its words (LEA-513): its preset, its recipient lines
 * exactly as typed when changed from the preset (unfinished addresses included), and its file box
 * once kept, whether or not its list has loaded yet.
 */
export function boxReply(input: {
  readonly all: boolean;
  readonly edited: boolean;
  readonly text: RecipientText;
  readonly box: string | null;
}): ComposerReply {
  return {
    all: input.all,
    recipients: input.edited
      ? { to: parts(input.text.to), cc: parts(input.text.cc), bcc: parts(input.text.bcc) }
      : null,
    files: input.box,
  };
}

/** A saved reply's recipient lines, or null where it kept the preset. */
export function savedRecipientText(reply: ComposerReply): RecipientText | null {
  const saved = reply.recipients;
  return saved ? { to: saved.to.join(""), cc: saved.cc.join(""), bcc: saved.bcc.join("") } : null;
}
